import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6bbb55a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" [공지] 국고 환수 임박! ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 종합소득세 ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "환급금", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("이 곧 ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "소멸", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("됩니다 ")
const _hoisted_9 = { class: "timer" }
const _hoisted_10 = { class: "clock-area" }
const _hoisted_11 = { class: "box-wrapper" }
const _hoisted_12 = { class: "upper-box-back" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_14 = { class: "box-wrapper" }
const _hoisted_15 = { class: "lower-box" }
const _hoisted_16 = { class: "upper-box-back" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_18 = { class: "box-wrapper" }
const _hoisted_19 = { class: "lower-box" }
const _hoisted_20 = { class: "upper-box-back" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_22 = { class: "box-wrapper" }
const _hoisted_23 = { class: "lower-box" }
const _hoisted_24 = { class: "upper-box-back" }
const _hoisted_25 = { class: "text-area" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" DAYS ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" HRS ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" MINS ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" SECS ")
const _hoisted_30 = { class: "tooltip" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 무료 조회 ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 환급 신청하기 ")

import { ref, onBeforeMount, onBeforeUnmount, watch } from 'vue' 

import Text from '@/components/common/TextComponent.vue'
import { XMark } from '@/styles/icon'
import { COLOR_SET } from '@/styles/variables'
import { SEC_BY_MS } from '@/constants/datetime'
import { useVisibilitychange } from '@/utils/useVisibilitychange'
import toRefund from '@/utils/toRefund'


export default /*#__PURE__*/_defineComponent({
  name: 'BannerForTimer',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



let timer: number
const targetDate = new Date('2025-05-28T23:30:00')
const visibilityState = useVisibilitychange()
const isClose = ref(false)
const remainSec = ref(0)
const remainDays = ref(0)
const remainHours = ref(0)
const remainMins = ref(0)
const isTimeOver = ref(false)

const isStartAnimationDays = ref(false)
const upperBoxDays = ref()
const lowerBoxDays = ref()

const isStartAnimationHours = ref(false)
const upperBoxHours = ref()
const lowerBoxHours = ref()

const isStartAnimationMins = ref(false)
const upperBoxMins = ref()
const lowerBoxMins = ref()

const isStartAnimationSec = ref(false)

const handleClose = () => {
  isClose.value = true
}

const animationEnd = () => {
  if (isClose.value) {
    emit('close')
  }
}

const setTimeGap = () => {
  const now = new Date()
  const diff = new Date(targetDate.getTime() - now.getTime())

  remainDays.value = diff.getUTCDate() - 1;
  remainHours.value = diff.getUTCHours()
  remainMins.value = diff.getUTCMinutes()
  remainSec.value = diff.getUTCSeconds()
  isTimeOver.value = diff.getTime() <= 0
  isStartAnimationSec.value = true
}

const getTwoDigit = (num: number) => {
  return num >= 10 ? num : `0${num}`
}

const startTimer = () => {
  if (!isTimeOver.value) {
    timer = window.setInterval(() => {
      if (remainSec.value <= 0) {
        remainSec.value = 59
        startAnimation('min')
      } else {
        remainSec.value =  remainSec.value - 1
      }
    }, SEC_BY_MS)
  } else {
    emit('close')
  }
}

onBeforeMount(() => {
  setTimeGap()
  startTimer()
})

onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer)
  }
})

const startAnimation = (type: 'day' | 'hour' | 'min') => {
  if (type === 'day') {
    isStartAnimationDays.value = true
  }
  if (type === 'hour') {
    isStartAnimationHours.value = true
  }
  if (type === 'min') {
    isStartAnimationMins.value = true
  }
}

const endAnimation = (type: 'day' | 'hour' | 'min') => {
  if (type === 'day') {
    isStartAnimationDays.value = false
    remainDays.value = remainDays.value - 1
  }
  if (type === 'hour') {
    isStartAnimationHours.value = false
    remainHours.value = remainHours.value - 1
  }
  if (type === 'min') {
    isStartAnimationMins.value = false
    remainMins.value = remainMins.value - 1
  }

  if (remainDays.value < 0) {
    isTimeOver.value = true
    emit('close')
  }
  if (remainMins.value < 0) {
    remainMins.value = 59
    startAnimation('hour')
  }
  if (remainHours.value < 0) {
    remainHours.value = 23
    startAnimation('day')
  }
}

watch((visibilityState), (newState) => {
  if (newState === 'visible') {
    setTimeGap()
    startTimer()
  }
  if (newState === 'hidden') {
    if (timer) {
      isStartAnimationSec.value = false
      clearInterval(timer)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["contents", { close: isClose.value }]),
        onAnimationend: animationEnd
      }, [
        _createElementVNode("div", {
          class: "header",
          onClick: handleClose
        }, [
          _createVNode(_unref(XMark), {
            size: "16px",
            color: _unref(COLOR_SET).gray02
          }, null, 8, ["color"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Text, {
            size: "24px",
            weight: "700",
            width: "220px",
            "text-align": "center",
            color: _unref(COLOR_SET).blue01
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(Text, {
            size: "20px",
            "text-align": "center"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                ref_key: "upperBoxDays",
                ref: upperBoxDays,
                class: _normalizeClass(["upper-box", {start: isStartAnimationDays.value}]),
                onAnimationend: _cache[0] || (_cache[0] = ($event: any) => (endAnimation('day')))
              }, [
                _createVNode(Text, {
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainDays.value)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 34),
              _createElementVNode("div", {
                ref_key: "lowerBoxDays",
                ref: lowerBoxDays,
                class: _normalizeClass(["lower-box", {start: isStartAnimationDays.value}])
              }, [
                _createVNode(Text, {
                  class: "lower-text",
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainDays.value)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 2),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(Text, {
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainDays.value-1 < 0 ? 0 : remainDays.value-1)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _createElementVNode("div", {
                ref_key: "lowerBoxDays",
                ref: lowerBoxDays,
                class: _normalizeClass(["lower-box-back", {start: isStartAnimationDays.value}])
              }, [
                _createVNode(Text, {
                  class: "lower-text",
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainDays.value-1 < 0 ? 0 : remainDays.value-1)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 2)
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                ref_key: "upperBoxHours",
                ref: upperBoxHours,
                class: _normalizeClass(["upper-box", {start: isStartAnimationHours.value}]),
                onAnimationend: _cache[1] || (_cache[1] = ($event: any) => (endAnimation('hour')))
              }, [
                _createVNode(Text, {
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainHours.value)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 34),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(Text, {
                  class: "lower-text",
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainHours.value)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(Text, {
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainHours.value-1 < 0 ? 23 : remainHours.value-1)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _createElementVNode("div", {
                ref_key: "lowerBoxHours",
                ref: lowerBoxHours,
                class: _normalizeClass(["lower-box-back", {start: isStartAnimationHours.value}])
              }, [
                _createVNode(Text, {
                  class: "lower-text",
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainHours.value-1 < 0 ? 23 : remainHours.value-1)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 2)
            ]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                ref_key: "upperBoxMins",
                ref: upperBoxMins,
                class: _normalizeClass(["upper-box", {start: isStartAnimationMins.value}]),
                onAnimationend: _cache[2] || (_cache[2] = ($event: any) => (endAnimation('min')))
              }, [
                _createVNode(Text, {
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainMins.value)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 34),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(Text, {
                  class: "lower-text",
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainMins.value)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(Text, {
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainMins.value-1 < 0 ? 59 : remainMins.value-1)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _createElementVNode("div", {
                ref_key: "lowerBoxMins",
                ref: lowerBoxMins,
                class: _normalizeClass(["lower-box-back", {start: isStartAnimationMins.value}])
              }, [
                _createVNode(Text, {
                  class: "lower-text",
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainMins.value-1 < 0 ? 59 : remainMins.value-1)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 2)
            ]),
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", {
                ref_key: "upperBoxMins",
                ref: upperBoxMins,
                class: "upper-box"
              }, [
                _createVNode(Text, {
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainSec.value)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 512),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(Text, {
                  class: "lower-text",
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainSec.value)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(Text, {
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainSec.value-1 < 0 ? 59 : remainSec.value-1)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _createElementVNode("div", {
                ref_key: "lowerBoxMins",
                ref: lowerBoxMins,
                class: _normalizeClass(["lower-box-back", {start: isStartAnimationMins.value}])
              }, [
                _createVNode(Text, {
                  class: "lower-text",
                  size: "30px",
                  color: _unref(COLOR_SET).white,
                  font: "Abel"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTwoDigit(remainSec.value-1 < 0 ? 59 : remainSec.value-1)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(Text, {
            size: "12px",
            font: "Abel"
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }),
          _createVNode(Text, {
            size: "12px",
            font: "Abel"
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }),
          _createVNode(Text, {
            size: "12px",
            font: "Abel"
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }),
          _createVNode(Text, {
            size: "12px",
            font: "Abel"
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(toRefund) && _unref(toRefund)(...args)))
        }, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(Text, {
              size: "12px",
              color: _unref(COLOR_SET).white,
              weight: "700"
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          _createVNode(Text, {
            size: "18px",
            color: _unref(COLOR_SET).white
          }, {
            default: _withCtx(() => [
              _hoisted_32
            ]),
            _: 1
          }, 8, ["color"])
        ])
      ], 34),
      _createElementVNode("div", {
        class: "overlay",
        onClick: handleClose
      })
    ])
  ]))
}
}

})